
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/auth/partnerships/seamless-ach",
      function () {
        return require("private-next-pages/docs/auth/partnerships/seamless-ach.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/auth/partnerships/seamless-ach"])
      });
    }
  